// The console's coral accent as Mantine props, shared by the pages that use it for their
// primary actions (Messages, Provider Operations). Class-string tokens stay in
// `formModal.tokens.ts`; this file holds only what is passed to Mantine as props, so the
// Tailwind literal rule does not apply here.
//
// Tokens live in a .ts file rather than alongside a component so fast refresh keeps working
// (see react-refresh/only-export-components).

/** Coral accent — primary actions, active tab. */
export const ACCENT = '#E5533D'

/** Shared Mantine props for a coral primary button. */
export const PRIMARY_BUTTON_PROPS = {
  color: ACCENT,
  radius: 'md',
  className: 'behuman-v2-mulish !font-bold',
} as const
